import { Button, Form, Col, Offcanvas, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import HelperService from "../../utility/HelperService";
import WebService from "../../utility/WebService";
import { Label } from "../../components/Label/Label";
import { EMAIL_REGEX } from "../../utility/constants";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import routePaths from "../../Navigation/routePaths";

interface PropData {
    isShow: boolean;
    isClose: Function;
    data: any;
}

interface formInterface {
    id: number
    uuid?: string
    name: string
    unit_id: number
    is_royalty_applicable?: boolean
    status?: string
    created_by?: number
    created_at?: Date
    updated_at?: Date
}

const AddStock = (props: PropData) => {
    const { handleSubmit, formState: { errors }, control, watch, reset, setValue, register } = useForm<formInterface>({});
    const watchAllFields = watch();
    const navigate = useNavigate();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [unitList, setUnitList] = useState<any>([]);

    useEffect(() => {
        if (props.isShow) {
            if (props.data && !HelperService.isEmptyObject(props.data)) {
                reset(props.data);
                setIsEdit(true);
            } else {
                reset({});
                resetForm();
                setIsEdit(false);
            }
            !unitList.length && getUnitList();
        }
    }, [props.isShow, props.data]);

    const handleFormSubmit = (data: formInterface) => {
        const url = isEdit ? `stock/update` : "stock/create";
        WebService[isEdit ? "putAPI" : 'postAPI']({
            action: url, body: data, id: "changePassword-btn",
        }).then((res: any) => {
            toast.success(res.message);
            closeModal(true);
        }).catch(() => { });
    };

    const closeModal = (e: boolean) => {
        reset();
        resetForm();
        props.isClose(e);
    };

    const resetForm = () => {
        setValue('name', '');
    };

    const getUnitList = () => {
        setIsLoading(true);
        WebService.getAPI({ action: "unit/list" })
            .then((res: any) => {
                setIsLoading(false);
                setUnitList(res.list.map((item: any) => ({ label: item.name, value: item.id })));
            })
            .catch(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            <Offcanvas show={props.isShow} onHide={props.isClose} placement="end" className="offcanvas-large">
                <Offcanvas.Header closeButton><Offcanvas.Title>{isEdit ? "Edit Stock" : "Add Stock"}</Offcanvas.Title></Offcanvas.Header>
                <Offcanvas.Body className="form-style">
                    <form className="form-style" onSubmit={handleSubmit(handleFormSubmit)}  >
                        <Row>
                            <Col lg={12} md={6} sm={12} className="mb-3">
                                {/* Name */}
                                <Controller
                                    control={control}
                                    name="name"
                                    rules={{ required: "Please Enter Name" }}
                                    render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                        <div className="mb-2">
                                            <Form.Label>Name</Form.Label><span className="text-danger">*</span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Name"
                                                onChange={onChange}
                                                onBlur={onBlur}
                                                value={watchAllFields.name}
                                            />
                                            {(errors["name"]?.message || Boolean(errors["name"]?.message) || (isTouched && !watchAllFields.name)) && (
                                                <div className="login-error">
                                                    <Label title={errors.name?.message || "Please Enter Name."} modeError={true} />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />

                                <Controller
                                    control={control}
                                    name="unit_id"
                                    rules={{ required: true }}
                                    render={({ field: { onChange } }) => (
                                        <Form.Group className="mb-3">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div>
                                                    <Form.Label>Unit</Form.Label>
                                                    <span className="text-danger">*</span>
                                                </div>
                                                <Link to={"#"} onClick={() => { navigate(routePaths.UNITS.path) }} className="font-14">Add Unit</Link>
                                            </div>
                                            <div className="input-group mb-1">
                                                <Select
                                                    isLoading={isLoading}
                                                    className="basic-single w-100"
                                                    classNamePrefix="select"
                                                    isSearchable={true}
                                                    options={unitList}
                                                    onChange={(e: any) => { onChange(e.value); }}
                                                    value={unitList?.find((option: any) => option.value === watchAllFields.unit_id)}
                                                    placeholder="Select Unit"
                                                />
                                            </div>
                                            {errors.unit_id && (
                                                <div className="login-error mb-3">
                                                    <Label
                                                        title={"Please select unit"}
                                                        modeError={true}
                                                    />
                                                </div>
                                            )}
                                        </Form.Group>
                                    )}
                                />

                                <Form.Check
                                    type="switch"
                                    id="custom-switch"
                                    label="Is Royalty Applicable"
                                    {...register("is_royalty_applicable", { value: false })} // Default value is false
                                    className="mb-3"
                                    checked={watchAllFields.is_royalty_applicable || false}
                                />

                            </Col>

                        </Row>
                        <div className="text-center border-top">
                            <Button
                                variant="dark"
                                className="btn-brand-1 px-5 mt-3 mb-3 me-2"
                                type="submit"
                                id="changePassword-btn"
                            >
                                {isEdit ? "Update" : "Add"}
                            </Button>
                            <Button
                                variant="light"
                                className="btn-brand-1 px-5 mt-3 mb-3"
                                type="button"
                                onClick={() => closeModal(false)}
                            >
                                Close
                            </Button>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default AddStock;
